/* eslint-disable react-hooks/exhaustive-deps */
import React from 'react'
import {
  SelectPageSize,
  StyledButtonGroups,
  StyledCard,
  TableWrapper,
  Table,
  THead,
  TBody,
} from '../../../components'
import Pagination from '../component/Pagination'
import {RowData} from './RowData'
import {RowFilter} from './RowFilter'
import {RowHead} from './RowHead'
import {useTableAudit} from './useTableAudit'

type Props = {
  className: string
}

const TableAudit: React.FC<Props> = ({className}) => {
  const {
    tableData,
    filter,
    loading,
    isError,
    rowNumber,
    numberURL,
    paginateNumber,
    handlePageSizeChange,
    RowEmptyData,
    RowLoader,
    RowErrorFetch,
  } = useTableAudit()

  return (
    <StyledCard>
      <StyledButtonGroups
        leftContent={
          <SelectPageSize
            initialValue={filter?.per_page ?? 5}
            onChange={(value: any) => handlePageSizeChange(value?.value)}
          />
        }
      />

      <TableWrapper>
        <Table>
          <THead>
            <RowHead />
          </THead>

          <TBody>
            <RowFilter />

            {loading ? (
              <RowLoader />
            ) : isError ? (
              <RowErrorFetch />
            ) : tableData.length === 0 ? (
              <RowEmptyData />
            ) : (
              <RowData items={tableData} rowNumber={rowNumber} />
            )}
          </TBody>
        </Table>
      </TableWrapper>

      <Pagination paginate={paginateNumber} test={numberURL} />
    </StyledCard>
  )
}

export {TableAudit}
